import React from 'react';
import styled from 'styled-components';
import Utils from 'shared/utils/index';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import useAssetPreloader from 'shared/components/AssetPreloader/useAssetPreloader';
import { SYSTEM_OS } from 'shared/constants';
import { isNotStandaloneMobilePWA } from '../../utils/mobileSupported';

const WidePreloader = ({ children }) => {
  const { percentLoaded } = useAssetPreloader();

  const isWindows = Utils.getSystemOs() === SYSTEM_OS.WINDOWS;

  return (
    <ContainerBackground className="AssetPreloader">
      <LoadingBarContainer className={Utils.ieVersion() !== 0 ? ' ieHack' : ''}>
        <LoadingBarBacking src={assetSource(ASSET_KEY.LOADING_BAR_BACKING)} alt="" />
        <LoadingBarFillContainer>
          <LoadingBarFillSide src={assetSource(ASSET_KEY.LOADING_FILL_SIDE)} alt="" />
          <LoadingBarFillInner src={assetSource(ASSET_KEY.LOADING_FILL_CENTER)} percentLoaded={percentLoaded} alt="" />
          <LoadingBarFillSide
            windows={isWindows}
            src={assetSource(ASSET_KEY.LOADING_FILL_SIDE)}
            transform="true"
            alt=""
          />
        </LoadingBarFillContainer>
      </LoadingBarContainer>
      {children}
    </ContainerBackground>
  );
};

export default WidePreloader;

const ContainerBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => !['theme'].includes(prop),
})`
  background-image: url(${assetSource(ASSET_KEY.LOADING_SCREEN)});
  ${({ theme }) => theme.AssetPreloader.ContainerBackground};
`;

const LoadingBarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['theme'].includes(prop),
})`
  position: absolute;
  height: 7rem;
  width: 40rem;
  top: ${isNotStandaloneMobilePWA ? 80 : 50}%;
  transform: translateY(-50%);
  overflow: hidden;
  border-radius: 4em;
  ${({ theme }) => theme.AssetPreloader.wideLoadingBarcontainer}
`;

const LoadingBarBacking = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
`;

const LoadingBarFillContainer = styled.div`
  display: flex;
  flex-direction: row;
  left: 0.25vw;
  position: absolute;
  height: 6.6rem;
  width: 98%;
  align-items: center;
`;

const LoadingBarFillSide = styled.img.withConfig({
  shouldForwardProp: (prop) => !['windows', 'transform'].includes(prop),
})`
  height: ${({ windows, transform }) => (windows && transform ? 'calc(100% - 1px)' : '100%')};
  margin-bottom: ${({ windows, transform }) => (windows && transform ? 1 : 0)}px;
  transform: ${({ transform }) => (transform ? 'rotateY(180deg)' : 'none')};
`;

const LoadingBarFillInner = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== 'percentLoaded',
})`
  height: 100%;
  width: ${({ percentLoaded }) => (percentLoaded > 3 ? percentLoaded - 10 : 0)}%;
  transition: all 1s ease;
  margin-inline: -1px;
`;

